import { useContext, useState } from 'react';
import { UserProfileContext } from '../../../context/userProfileContext';
import TimeLine from '../timeLine/TimeLine';
import MainData from './InsurancePageMainData';
import { createInsurance } from '../../../utils/api/insurance';
import ConfirmModal from '../../../components/ConfirmModal';
import { useTranslation } from 'react-i18next';
import Loader from '../../../components/Loader';
import ClientPoliciesReadOnly from './ClientPoliciesReadOnly';

const Insurance = () => {
    const { t } = useTranslation('insurance');
    const { profileContextData } = useContext(UserProfileContext);
    const { client } = profileContextData;

    const [showSpouseWarning, setShowSpouseWarning] = useState(false);
    const [pendingCreationReason, setPendingCreationReason] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);

    const handleCreateRound = async (reason: string) => {
        const result = await createInsurance(client._id, reason);

        if (result.spouseInsuranceWarning) {
            setPendingCreationReason(reason);
            setShowSpouseWarning(true);
        }
    };

    const confirmSpouseInsuranceCreation = async () => {
        setIsLoading(true);
        setShowSpouseWarning(false);
        try {
            await createInsurance(client._id, pendingCreationReason, true);
            window.location.reload();
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    };

    return (
        <div className={`regular-modules insurance ${profileContextData.expandClientData ? 'data-expanded' : ''}`}>
            {isLoading && <Loader />}
            <div className={'timeline-row-wrapper not-active-module'}>
                <TimeLine onCreateRound={handleCreateRound} />
            </div>
            {profileContextData.currentRound ? <MainData /> : <ClientPoliciesReadOnly />}

            <ConfirmModal
                show={showSpouseWarning}
                title={t('New Insurance for couple')}
                body={t('This client will be opened as handled by spouse, and the spouse profile will be the champion')}
                handleConfirm={confirmSpouseInsuranceCreation}
                noHide={() => setShowSpouseWarning(false)}
                confirmText={t('Ok')}
                cancelText={t('Cancel')}
                dir="rtl"
            />
        </div>
    );
};

export default Insurance;
